import React, { useContext } from 'react'

import { UserContext } from '@doist/marketist'

import { Footer, Navbar, Seo } from 'components'
import { CustomerStories } from 'components/customer-stories/CustomerStories'
import { GetServerSidePropsContext, NextPage } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { getCommonServerSideProps } from 'services'
import CustomerClient from 'services/contentful/clients/CustomerClient'
import { getOgImageURL } from 'services/ogimage'
import { Customer } from 'types/contentful'

interface Props {
    customers: Customer[]
}

export const CustomerStoriesPage: NextPage<Props> = ({ customers }) => {
    const { isAuthenticated } = useContext(UserContext)
    const { t, i18n } = useTranslation('customers')

    return (
        <>
            <Navbar isAuth={isAuthenticated} />
            <Seo
                path="/customer-stories"
                title={t('seo.title')}
                description={t('seo.description')}
                lang={i18n.language}
                images={[
                    {
                        url: getOgImageURL('og-image-customers.jpg'),
                        alt: t('illustrationAlt'),
                    },
                ]}
            />

            <CustomerStories customers={customers} />
            <Footer textSize="major-xl" hairlineBackgroundColor="var(--ui-border)" />
        </>
    )
}

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
    const { locale, ...commonProps } = await getCommonServerSideProps(ctx)
    const customers = await CustomerClient.getCustomers(locale)

    return {
        props: {
            customers,
            ...commonProps,
            ...(await serverSideTranslations(locale, ['common', 'customers'])),
        },
    }
}

export default CustomerStoriesPage
